import { Injectable, Inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, catchError, exhaustMap, tap, mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { ToastifyService } from '../../shared/toastify-service';
import { VendorServiceCharges, VendorServiceChargesFailure, VendorServiceChargesSuccess, fetchClientServiceCharges, fetchClientServiceChargesSuccess, fetchClientServiceChargesFailure, fetchVendorServiceCharges, fetchVendorServiceChargesSuccess, fetchVendorServiceChargesFailure, ClientServiceCharges, ClientServiceChargesSuccess, ClientServiceChargesFailure, updateClientServiceCharges, updateClientServiceChargesSuccess, updateClientServiceChargesFailure, StampingPartnerServiceCharges, StampingPartnerServiceChargesSuccess, StampingPartnerServiceChargesFailure, updateStampingPartnerServiceCharges, updateStampingPartnerServiceChargesSuccess, updateStampingPartnerServiceChargesFailure, fetchStampingPartnerServiceCharges, fetchStampingPartnerServiceChargesSuccess, fetchStampingPartnerServiceChargesFailure } from './servicecharges.actions';
import { ServiceChargesService } from '../../core/services/servicecharges.service';

@Injectable()
export class ServiceChargesEffects {

  //Service charges
  vendorServiceCharges$ = createEffect(() =>
    this.actions$.pipe(
      ofType(VendorServiceCharges),
      mergeMap(({ vendorservicechargesobj }) => {
        return this.servicechargesservice.vendorservicecharges(vendorservicechargesobj).pipe(
          map((user: any) => {
            return VendorServiceChargesSuccess();
          }),
          catchError((error) => of(VendorServiceChargesFailure({ error })), // Closing parenthesis added here
          ));
      })
    )
  );

  vendorServiceChargesSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(VendorServiceChargesSuccess),
        tap((user: any) => {
          this.toastifyService.showSuccessMessage("Service charges updated successfully.");
        })
      ),
    { dispatch: false }
  );

  VendorServiceChargesFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(VendorServiceChargesFailure),
        tap((error: any) => {
          this.toastifyService.showErrorMessage(error.error.message);
        })
      ),
    { dispatch: false }
  );

  //Fetch Client Service charges
  fetchClientServiceCharges$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchClientServiceCharges),
      mergeMap(({ clientguid }) => {
        return this.servicechargesservice.getclientservicecharges(clientguid).pipe(
          map((servicecharges: any) => {
            return fetchClientServiceChargesSuccess({servicecharges});
          }),
          catchError((error) => of(fetchClientServiceChargesFailure({ error })), // Closing parenthesis added here
          ));
      })
    )
  );

  fetchClientServiceChargesFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fetchClientServiceChargesFailure),
        tap((error: any) => {
          this.toastifyService.showErrorMessage(error.error.message);
        })
      ),
    { dispatch: false }
  );

  //Fetch Vendor Service charges
  fetchVendorServiceCharges$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchVendorServiceCharges),
      mergeMap(() => {
        return this.servicechargesservice.getvendorservicecharges().pipe(
          map((servicecharges: any) => {
            return fetchVendorServiceChargesSuccess({servicecharges});
          }),
          catchError((error) => of(fetchVendorServiceChargesFailure({ error })), // Closing parenthesis added here
          ));
      })
    )
  );

  fetchVendorServiceChargesFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fetchVendorServiceChargesFailure),
        tap((error: any) => {
          this.toastifyService.showErrorMessage(error.error.message);
        })
      ),
    { dispatch: false }
  );

  //Service charges
  ClientServiceCharges$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ClientServiceCharges),
      mergeMap(({ clientservicechargesobj, clientguid }) => {
        return this.servicechargesservice.addclientservicecharges(clientservicechargesobj, clientguid).pipe(
          map((user: any) => {
            return ClientServiceChargesSuccess();
          }),
          catchError((error) => of(ClientServiceChargesFailure({ error })), // Closing parenthesis added here
          ));
      })
    )
  );

  ClientChargesSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(ClientServiceChargesSuccess),
        tap((user: any) => {
          this.toastifyService.showSuccessMessage("Service charges updated successfully.");
        })
      ),
    { dispatch: false }
  );

  ClientChargesFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(ClientServiceChargesFailure),
        tap((error: any) => {
          this.toastifyService.showErrorMessage(error.error.message);
        })
      ),
    { dispatch: false }
  );

  //Update Service charges
  updateClientServiceCharges$ = createEffect(() =>
    this.actions$.pipe(
      ofType(updateClientServiceCharges),
      mergeMap(({ clientservicechargesobj, servicechargesid }) => {
        return this.servicechargesservice.editclientservicecharges(clientservicechargesobj, servicechargesid).pipe(
          map((user: any) => {
            return updateClientServiceChargesSuccess();
          }),
          catchError((error) => of(updateClientServiceChargesFailure({ error })), // Closing parenthesis added here
          ));
      })
    )
  );

  updateClientChargesSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(updateClientServiceChargesSuccess),
        tap((user: any) => {
          this.toastifyService.showSuccessMessage("Service charges updated successfully.");
        })
      ),
    { dispatch: false }
  );

  updateClientChargesFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(updateClientServiceChargesFailure),
        tap((error: any) => {
          this.toastifyService.showErrorMessage(error.error.message);
        })
      ),
    { dispatch: false }
  );

  //Service charges
  StampingPartnerServiceCharges$ = createEffect(() =>
    this.actions$.pipe(
      ofType(StampingPartnerServiceCharges),
      mergeMap(({ stampingpartnerservicechargesobj, stampingpartnerguid }) => {
        return this.servicechargesservice.stampingpartnerservicecharges(stampingpartnerservicechargesobj, stampingpartnerguid).pipe(
          map((user: any) => {
            return StampingPartnerServiceChargesSuccess();
          }),
          catchError((error) => of(StampingPartnerServiceChargesFailure({ error })), // Closing parenthesis added here
          ));
      })
    )
  );

  StampingPartnerServiceChargesSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(StampingPartnerServiceChargesSuccess),
        tap((user: any) => {
          this.toastifyService.showSuccessMessage("Stamping partner service charges updated successfully.");
        })
      ),
    { dispatch: false }
  );

  StampingPartnerServiceChargesFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(StampingPartnerServiceChargesFailure),
        tap((error: any) => {
          this.toastifyService.showErrorMessage(error.error.message);
        })
      ),
    { dispatch: false }
  );

  //Update Service charges
  updateStampingPartnerServiceCharges$ = createEffect(() =>
    this.actions$.pipe(
      ofType(updateStampingPartnerServiceCharges),
      mergeMap(({ stampingpartnerservicechargesobj, servicechargesid }) => {
        return this.servicechargesservice.editstampingpartnerservicecharges(stampingpartnerservicechargesobj, servicechargesid).pipe(
          map((user: any) => {
            return updateStampingPartnerServiceChargesSuccess();
          }),
          catchError((error) => of(updateStampingPartnerServiceChargesFailure({ error })), // Closing parenthesis added here
          ));
      })
    )
  );

  updateStampingPartnerServiceChargesSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(updateStampingPartnerServiceChargesSuccess),
        tap((user: any) => {
          this.toastifyService.showSuccessMessage("Service charges updated successfully.");
        })
      ),
    { dispatch: false }
  );

  updateStampingPartnerServiceChargesFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(updateStampingPartnerServiceChargesFailure),
        tap((error: any) => {
          this.toastifyService.showErrorMessage(error.error.message);
        })
      ),
    { dispatch: false }
  );

  //Fetch Stamping Partner Service charges
  fetchStampingPartnerServiceCharges$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchStampingPartnerServiceCharges),
      mergeMap(({ stampingpartnerguid }) => {
        return this.servicechargesservice.getstampingpartnerservicecharges(stampingpartnerguid).pipe(
          map((servicecharges: any) => {
            return fetchStampingPartnerServiceChargesSuccess({servicecharges});
          }),
          catchError((error) => of(fetchStampingPartnerServiceChargesFailure({ error })), // Closing parenthesis added here
          ));
      })
    )
  );

  fetchStampingPartnerServiceChargesFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fetchStampingPartnerServiceChargesFailure),
        tap((error: any) => {
          if(error.error.status == 404) {
            this.toastifyService.showInfoMessage("NO SERVICE CHARGES FOUND. PLEASE GO AHEAD AND GENERATE AT YOUR END.");
          } else {
            this.toastifyService.showErrorMessage(error.error.message);
          }
        })
      ),
    { dispatch: false }
  );

  constructor(
    @Inject(Actions) private actions$: Actions,
    private toastifyService: ToastifyService,
    private servicechargesservice: ServiceChargesService) { }
}